import template from './rw-app-version.html';

export default {
  template,
  controller: 'RwAppVersionController',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-app-version/rw-app-version-component.js